<template>
  <div>
    <br />
    <div class="row justify-content-end">
      <div class="col-auto">
        <button
          class="btn btn-secondary"
          @click="$router.push({ name: 'seller-sales-items-create' })"
        >
          <i class="bi bi-file-earmark-plus fs-4"></i>
          Ajouter d'autres articles
        </button>
      </div>
    </div>
    <hr />
    <div class="row justify-content-between">
      <div class="col-xl col-12 d-flex">
        <div class="col-auto">Total Quantite :</div>
        <div class="col">
          <span
            v-if="numberItems != ''"
            class="fw-bold bg-warning px-2 py-1 rounded"
          >
            {{ numberItems }}
          </span>
          Élément
        </div>
      </div>

      <div class="col-xl col-12 d-flex">
        <div class="col-auto">Quantité totale :</div>
        <div class="col">
          <span
            v-if="totalQuantityItems != ''"
            class="fw-bold bg-warning px-2 py-1 rounded"
          >
            {{ totalQuantityItems }}
          </span>
        </div>
      </div>

      <div class="col-xl col-12 d-flex">
        <div class="col-auto">Montant Total (TTC*) :</div>
        <div class="col">
          <span
            v-if="totalPriceTTCItems != ''"
            class="fw-bold bg-warning px-2 py-1 rounded"
          >
            {{ totalPriceTTCItems }}
          </span>
          DH
        </div>
      </div>
    </div>
    <hr />
    <br />
    <div class="row align-items-end">
      <div class="col-xl-3 col-12 my-3">
        <label for="">Client Vendeur <span class="text-danger">*</span> </label>
        <vue-select
          :options="sellerCustomers"
          v-model="sellerSale.seller_customer_reference"
          placeholder="Select an option"
          labelColumn="fullName"
          valueColumn="reference"
        />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Date <span class="text-danger">*</span></label>
        <input type="date" v-model="sellerSale.date" class="form-control" />
      </div>

      <div class="col-auto my-3">
        <label for=""> </label>
        <button @click="selectTodayDate" class="btn btn-secondary">
          Date d'aujourd'hui
        </button>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Échéance </label>
        <input type="date" v-model="sellerSale.deadline" class="form-control" />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Date de livraison </label>
        <input
          type="datetime-local"
          v-model="sellerSale.deliveryDateTime"
          class="form-control"
        />
      </div>

      <div class="col-xl-12 col-12 my-3">
        <label for=""> Remarque </label>
        <textarea
          v-model="sellerSale.remark"
          class="form-control"
          rows="3"
        ></textarea>
      </div>
    </div>

    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-xl-8 col-12"></div>
      <div class="col-xl-auto col-12">
        <button class="btn btn-success" @click="save(sellerSale)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-xl-12 col-12">
        (<span class="text-danger">*</span>) : Ce champ est obligatoire.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      sellerSale: {
        date: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        amountPaid: 0.0,
        amountUnpaid: 0.0,
      },
    };
  },
  computed: {
    ...mapGetters("sellerSale", {
      sale_items: "getItems",
      totalQuantityItems: "totalQuantityItems",
      totalPriceTTCItems: "totalPriceTTCItems",
      totalPriceHTItems: "totalPriceHTItems",
      numberItems: "numberItems",
    }),

    ...mapGetters("sellerCustomer", {
      sellerCustomers: "getAll",
    }),
  },
  methods: {
    async save(data) {
      data.totalPriceTTC = this.totalPriceTTCItems;
      data.totalPriceHT = this.totalPriceHTItems;
      data.totalPriceTVA = this.totalPriceTTCItems - this.totalPriceHTItems;
      data.totalQuantity = this.totalQuantityItems;
      data.amountPaid = 0;
      data.amountUnpaid = this.totalPriceTTCItems;
      await this.$store.dispatch("sellerSale/store", data);
    },
    async refresh() {
      this.$store.dispatch("sellerSale/getAllItems");
    },
    async selectTodayDate() {
      this.sellerSale.date = new Date(
        new Date().setFullYear(new Date().getFullYear())
      )
        .toLocaleString("en-CA")
        .split(",")[0];
    },
  },
  async beforeMount() {
    await this.$store.dispatch("sellerSale/getAllItems");
    await this.$store.dispatch("sellerCustomer/getAll");
    if (!this.numberItems) {
      await this.$store.dispatch(
        "notification/store",
        {
          status: "error",
          message: "Aucun élément n'est ajouté. Veuillez en ajouter.",
        },
        { root: true }
      );
      await this.$router.push({ name: "seller-sales-items-create" });
    }
  },
};
</script>
